import { contactVerificationService } from '@/data/services/contact-verification/contact-verification-service'
import { FormattedUserProfileResponse } from '@/data/services/contact-verification/contact-verification-service-types'

export async function contactVerificationLoader(): Promise<FormattedUserProfileResponse> {
  return await contactVerificationService.fetchUserProfile()
}
